import axios from 'axios';

// 🎯 SINGLE CONFIGURATION - Change this line only!
const IS_DEVELOPMENT = false; // ← Change this to false for production

const getApiUrl = () => {
  if (IS_DEVELOPMENT) {
    return 'http://localhost:30007';
  } else {
    return 'https://api.email-auto.upgrowventures.com';
  }
};

// Configure axios defaults
const apiUrl = getApiUrl();

const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Don't auto-redirect on 401 - let AuthContext handle it
    // This prevents double-handling and race conditions
    return Promise.reject(error);
  }
);

export default apiClient;
export { getApiUrl };
